import React, { useState, useEffect } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import CancelIcon from '@mui/icons-material/Cancel';
import ValidationFeedback from '../validation.feedback';
import ConfirmDialog from '../confirm.dialog';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import GoogleSheetsService from '../../service/googlesheet.service';

let resetInfoTimeoutId = -1;

const HandleSpainActivityBooking = () => {
    const [loading, setLoading] = useState(true);
    const [cancelling, setCancelling] = useState({});
    const [activityRegistrations, setActivityRegistrations] = useState([]);
    const [email, setEmail] = useState('');
    const [confirmCancelOpen, setConfirmCancelOpen] = useState(false);
    const [confirmCancelTarget, setConfirmCancelTarget] = useState({});
    const [error, setError] = useState('');
    const [info, setInfo] = useState('');

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        GoogleSheetsService.getActivityRegistrations(queryParams.get("b")).then((result) => {
            if (result && result.length > 0) {
                setEmail(result[0].participants[0].email);
            }
            setActivityRegistrations(result ?? []);
            setLoading(false);
        });
    }, []);

    const cancelActivityRegistration = (activityId, participantName) => {
        updateValidation('', '');
        setConfirmCancelOpen(false);
        var updatedCancelling = { ...cancelling };
        updatedCancelling[activityId + '-' + participantName] = true;
        setCancelling(updatedCancelling);

        GoogleSheetsService.cancelActivityRegistration(activityId, email, participantName).then((success) => {
            if (success === true) {
                const updatedActivityRegistrations = [...activityRegistrations];
                const activityIndex = updatedActivityRegistrations.findIndex(_ => _.activityId === activityId);
                const participants = updatedActivityRegistrations[activityIndex].participants;
                const participantIndex = participants.findIndex(_ => _.name === participantName);

                updatedActivityRegistrations[activityIndex].participants[participantIndex].status = 4;
                updatedActivityRegistrations[activityIndex].participants = participants;

                setActivityRegistrations(updatedActivityRegistrations);
                updateValidation(`${participantName} är nu avbokad från ${confirmCancelTarget?.activity?.dateDisplay} - ${confirmCancelTarget?.activity?.name}`, '');
            } else {
                updateValidation('', 'Aktiviteten börjar snart! Du kan tyvärr inte längre avboka deltagare');
            }

            var updatedCancelling = { ...cancelling };
            updatedCancelling[activityId + '-' + participantName] = false;
            setCancelling(updatedCancelling);
        });
    }

    const updateValidation = (newInfo, newError) => {
        setInfo(newInfo);
        setError(newError);
        clearTimeout(resetInfoTimeoutId);
        resetInfoTimeoutId = setTimeout(() => {
            setInfo('');
            setError('');
        }, 10000);
    }

    return (
        <div>
            {loading === true && <h3 className='s4g-select-competition-type-header'>Hämtar din bokning, vänligen vänta lite...</h3>}
            {loading === false && (activityRegistrations === undefined || activityRegistrations === null || activityRegistrations.length === 0) &&
                <div>
                    <h3 className='s4g-select-competition-type-header'>Vi kan inte hitta din bokning! :(</h3>
                    <p className='s4g-info-text'>Kontrollera att du använt rätt länk från ditt boknings-mail.<br />Om felet kvarstår, vänligen hör av dig till oss via mail <a href='mailto:golf@stay4golf.se'>golf@stay4golf.se</a>, eller ringa oss på <a href='tel:040294400' className='s4g-no-wrap'>040 – 29 44 00.</a></p>
                </div>
            }
            {loading === false && activityRegistrations !== undefined && activityRegistrations !== null && activityRegistrations.length > 0 && activityRegistrations.filter(a => a.participants.filter(p => p.status !== 4).length > 0).length === 0 &&
                <div>
                    <h3 className='s4g-select-competition-type-header'>Avbokad</h3>
                    <p className='s4g-info-text'>Samtliga deltagare för denna aktivitet är redan avbokade. Om du har några frågor vänligen hör av dig till oss via mail <a href='mailto:golf@stay4golf.se'>golf@stay4golf.se</a>, eller ringa oss på <a href='tel:040294400' className='s4g-no-wrap'>040 – 29 44 00.</a></p>
                </div>
            }
            {loading === false && activityRegistrations !== undefined && activityRegistrations !== null && activityRegistrations.length > 0 && activityRegistrations.filter(a => a.participants.filter(p => p.status !== 4).length > 0).length > 0 &&
                <div className="s4g-reg-form">
                    <div className='s4g-section'>
                        <h3>Aktiviteter</h3>
                        <p><i>Klicka på en aktivitet för mer information.</i></p>
                        {activityRegistrations.filter(a => a.participants.filter(p => p.status !== 4).length > 0).map((activityRegistration) => {
                            return (
                                <Accordion sx={{ width: 'inherit' }} key={activityRegistration.activity.name} >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="activity-content"
                                        id="activity-header"
                                    >
                                        <div>
                                            <h5>{activityRegistration.activity.dateDisplay} - {activityRegistration.activity.name}</h5>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className='s4g-a-names'>
                                            {activityRegistration.participants.filter(p => p.status !== 4).map(p => {
                                                return (
                                                    <div className='s4g-a-name d-flex' key={p.name}>
                                                        <LoadingButton sx={{ marginRight: '1rem' }}
                                                            loading={cancelling[activityRegistration.activity.id + '-' + p.name] === true}
                                                            variant="outlined"
                                                            loadingPosition="start"
                                                            startIcon={<CancelIcon />}
                                                            onClick={() => {
                                                                setConfirmCancelTarget({
                                                                    participantName: p.name,
                                                                    activity: activityRegistration.activity
                                                                });
                                                                setConfirmCancelOpen(true);
                                                            }}>
                                                            Avboka
                                                        </LoadingButton>
                                                        <h5>{p.name} {p.option.length > 0 ? '(' + p.option + ')' : ''}</h5>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                    </div>
                    <ValidationFeedback validationInfo={info} validationError={error} />
                </div>
            }
            <ConfirmDialog
                open={confirmCancelOpen}
                name={confirmCancelTarget?.participantName}
                target={`${confirmCancelTarget?.activity?.dateDisplay} - ${confirmCancelTarget?.activity?.name}`}
                confirm={() => cancelActivityRegistration(confirmCancelTarget.activity.id, confirmCancelTarget.participantName)}
                close={() => setConfirmCancelOpen(false)}
            />
        </div>
    );
}

export default HandleSpainActivityBooking;
